import React from "react";
import {Navigate, Outlet, Route} from "react-router-dom";
import User from "../../Models/User";
import {useSelector} from "react-redux";


export const NoLoggedRoute = ({component: Component, ...rest}) => {

   const logged = useSelector((state) => state.users.logged)

   return !logged ? <Outlet />:<Navigate to="/dashboard" />
}